<div class="list-item__body mru-item__body"
    [ohpContextMenuTarget]="contextMenu" [ohpContextMenuDisabled]="actionsMenuOpen || actionContextMenuEnabled"
    [ohpActionContextMenuTarget]="actionContextMenu" [ohpActionContextMenuDisabled]="!actionContextMenuEnabled">
    <div *ngIf="mruItemState === MRU_ITEM_LOADING_STATE" class="mru-list-item-overlay">
        <div class="spinner-container spinner-container--wh-100">
            <div class="ms-Spinner-circle ms-Spinner--large"></div>
        </div>
    </div>
    <a class="mru-list-item"
       [id]="listId + '-' + item.id"
       [ngClass]="{ 'list-item__focused': itemFocused || actionsMenuOpen, 'mru-list-item__padding': showAsListItem(), 'mru-list-item__padding--mobile': showAsListItem() && showMobileShareAndActivity, 'mru-list-item--local': item.isLocal }"
       href="{{ url }}"
       rel="noopener"
       ohpDefaultLinkTarget
       [attr.aria-label]="descriptiveAriaLabel"
       data-clicklog="custom"
       (click)="onItemClick($event)"
       (focus)="onFocus()"
       (blur)="onBlur()"
       [ohpFocusOnLoad]="focusOnLoad"
       [ohpDocumentPreload]="{ item: item, wdOriginType: getWdOriginTaskForClick() }"
       [ohpWacHoverPreboot]="{ item: item, wdOriginType: getWdOriginTaskForClick() }"
       [hoverDelay]="wacHostHoverPrebootEnabled ? 500 : showAsCard() ? 200 : 150"
       #mruListItem>
       <div *ngIf="showAsCard()" class="document-card ms-bgc-w"
            [ngClass]="{ 'carousel-card': isRecommended || isOfficeFeed,
            'document-card--no-padding': uiCardType === 'borderless' || fluentRefresh,
            'document-card--motion': recommendedNewCards,
            'document-card--fluent': fluentRefresh }"
            [@recommendedCardHover]=isHovered
            (mouseover)="recommendedHover('hovered')"
            (mouseleave)="recommendedHover('unhovered')">
            <div *ngIf="showActivity && !recommendedNewCards && !isMyAnalytics" class="document-card__header" [ngClass]="{'document-card__header--fluent': fluentRefresh}">
                <ohp-activity-description [activities]="item.activities" [lastViewedTime]="item.lastViewedTime" [numLines]="2" [activityDescriptionInput]="item.activity" [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink" [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink" [docId]="item.docId" [index]="index" [fileType]="item.fileType" [navId]="item.navigationId" [area]="instrumentationArea">
                    <ohp-activity-description *ngIf="item.lastModifiedActivity && !item.activity" [activities]="item.lastModifiedActivity" [numLines]="2" [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink" [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink" [docId]="item.docId" [index]="index" [fileType]="item.fileType" [navId]="item.navigationId" [area]="instrumentationArea"></ohp-activity-description>
                </ohp-activity-description>
            </div>
            <div *ngIf="showActivity && !recommendedNewCards && isMyAnalytics" class="document-card__header" [ngClass]="{'document-card__header--fluent': fluentRefresh}" [ohpPeopleCard]="item.activityUser.email">
                <ohp-activity-description [activities]="item.activities" [lastViewedTime]="item.lastViewedTime" [numLines]="2" [activityDescriptionInput]="item.activity" [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink" [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink" [docId]="item.docId" [index]="index" [fileType]="item.fileType" [navId]="item.navigationId" [showIcon]="false" [person]="item.activity?.people[0] | activityPersonToPerson" [area]="instrumentationArea">
                    <ohp-activity-description *ngIf="item.lastModifiedActivity && !item.activity" [activities]="item.lastModifiedActivity" [numLines]="2" [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink" [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink" [docId]="item.docId" [index]="index" [fileType]="item.fileType" [navId]="item.navigationId" [area]="instrumentationArea"></ohp-activity-description>
                </ohp-activity-description>
            </div>
            <div *ngIf="!isUpcomingMeeting && !isMyAnalytics"
                 class="document-card__thumbnail-container"
                 [ngClass]="{ 'document-card__thumbnail-container--recommended': isRecommended || isOfficeFeed,
                              'document-card_thumbnail-container--rounded document-card__thumbnail-container--borderless': uiCardType === 'borderless',
                              'document-card__thumbnail-container--rounded-card': (isRecommended || isOfficeFeed) && recommendedNewCards,
                              'document-card__thumbnail-container--suggested-actions': fluentRefresh}">
                <div *ngIf="isStreamsVideo">
                    <div *ngIf="streamsThumbnailLoaded" class="opacity-overlay"></div>
                    <div [hidden]="!streamsThumbnailLoaded" class="document-card__thumbnail-wrapper">
                        <img *ngIf="streamsVideoThumbnail | async as image" class="document-card__thumbnail" [src]="image" alt="{{ thumbnailAltText }}" />
                    </div>
                    <div class="video-duration" *ngIf="item.mediaDuration">
                        {{ item.mediaDuration }}
                    </div>
                </div>
                <ng-container *ngIf="thumbnailApiEnabled && !isStreamsVideo && !isNewsArticle && !isMicrosoftForms">
                    <div *ngIf="thumbnailLoaded" class="opacity-overlay"></div>
                    <div [hidden]="!thumbnailLoaded" class="document-card__thumbnail-wrapper">
                        <img *ngIf="thumbnail | async as image" class="document-card__thumbnail" [src]="image" alt="{{ thumbnailAltText }}" />
                    </div>
                    <div *ngIf="!thumbnailLoaded && fluentRefresh"
                        [ngStyle]="{'background-color': workloadColorPromise | async }"
                        class="document-card--suggested-actions--fallback-background">
                    </div>
                </ng-container>
                <ng-container *ngIf="(!thumbnailApiEnabled || isNewsArticle || isMicrosoftForms) && thumbnailUrl && !isStreamsVideo">
                    <div *ngIf="thumbnailLoaded" class="opacity-overlay"></div>
                    <div [hidden]="!thumbnailLoaded" class="document-card__thumbnail-wrapper" [ngStyle]="{'background-color': (item.thumbnails  && item.thumbnails.backgroundColor ) ? item.thumbnails.backgroundColor  : 'transparent'}">
                        <img *ngIf="thumbnailSWEnabled" class="document-card__thumbnail" [ngClass]="{'document-card__thumbnail-officefeed-news': isNewsArticle}" [src]="thumbnailUrl | urlCachePipe | async" alt="{{ thumbnailAltText }}" (load)="onThumbnailLoad()" (error)="onThumbnailError()" />
                        <img *ngIf="!thumbnailSWEnabled" class="document-card__thumbnail" [ngClass]="{'document-card__thumbnail-officefeed-news': isNewsArticle}" [src]="thumbnailUrl" alt="{{ thumbnailAltText }}" (load)="onThumbnailLoad()" (error)="onThumbnailError()" />
                    </div>
                </ng-container>
                <ng-container *ngIf="thumbnailApiEnabled"> <!--TODO: Simplify this-->
                    <div *ngIf="(!thumbnailLoaded && !isStreamsVideo) || (!streamsThumbnailLoaded && isStreamsVideo)" class="document-card__thumbnail-placeholder">
                        <div *ngIf="!item.iconUrl" [ngClass]="item.documentIconWithSize('64x64')"></div>
                        <img *ngIf="item.iconUrl" class="document-icon--64x64" src="{{item.iconUrl}}"/>
                    </div>
                    <div *ngIf="!recommendedNewCards && (thumbnailLoaded || (streamsThumbnailLoaded && isStreamsVideo)) && !isNewsArticle && uiCardType !== 'borderless' && !fluentRefresh">
                        <div *ngIf="iconFontClass()" class="mru-list-item__icon-in-preview" [ngStyle]="{'color': iconFontColor()}">
                            <ohp-icon-font [iconFontCssClass]="iconFontClass()" size="16" #fileIconElement></ohp-icon-font>
                        </div>
                        <div *ngIf="!iconFontClass()" class="mru-list-item__icon-in-preview mru-list-item__document-icon-in-preview" [ngClass]="item.documentIconWithSize('20x20')"></div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!thumbnailApiEnabled">
                    <div *ngIf="((!thumbnailLoaded || !thumbnailUrl) && !isStreamsVideo) || (!streamsThumbnailLoaded && isStreamsVideo)" class="document-card__thumbnail-placeholder">
                        <div *ngIf="!item.iconUrl" [ngClass]="item.documentIconWithSize('64x64')"></div>
                        <img *ngIf="item.iconUrl" class="document-icon--64x64" src="{{item.iconUrl}}"/>
                    </div>
                    <div *ngIf="!recommendedNewCards && ((thumbnailUrl && thumbnailLoaded) || (streamsThumbnailLoaded && isStreamsVideo)) && !isNewsArticle && uiCardType !== 'borderless' && !fluentRefresh">
                        <div *ngIf="iconFontClass()" class="mru-list-item__icon-in-preview" [ngStyle]="{'color': iconFontColor()}">
                            <ohp-icon-font [iconFontCssClass]="iconFontClass()" size="16" #fileIconElement></ohp-icon-font>
                        </div>
                        <div *ngIf="!iconFontClass()" class="mru-list-item__icon-in-preview mru-list-item__document-icon-in-preview" [ngClass]="item.documentIconWithSize('20x20')"></div>
                    </div>
                </ng-container>
            </div>
            <ng-template *ngIf="isUpcomingMeeting" [ngTemplateOutlet]="upcomingMeetingTitle"></ng-template>
            <ng-template *ngIf="isMyAnalytics" [ngTemplateOutlet]="myAnalyticsTitle"></ng-template>
            <div *ngIf="recommendedNewCards" class="document-card__info centered-flex-container" [ngClass]="{ 'document-card__info--expanded': uiCardType === 'borderless', 'document-card__info--fluent': fluentRefresh }">
                <div *ngIf="showActivity" class="list-item__flex-grow">
                    <ohp-activity-description [activities]="item.activities" [lastViewedTime]="item.lastViewedTime" [numLines]="2" [activityDescriptionInput]="item.activity" [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink" [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink" [docId]="item.docId" [index]="index" [fileType]="item.fileType" [iconSize]="20" [title]="recommendedNewCards && item.title" [area]="instrumentationArea">
                        <ohp-activity-description *ngIf="item.lastModifiedActivity && !item.activity" [activities]="item.lastModifiedActivity" [numLines]="2" [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink" [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink" [docId]="item.docId" [index]="index" [fileType]="item.fileType" [iconSize]="20" [title]="recommendedNewCards && item.title" [navId]="item.navigationId" [area]="instrumentationArea"></ohp-activity-description>
                    </ohp-activity-description>
                </div>
                <div *ngIf="showActionsMenu" class="document-card__menu" [ngClass]="{'document-card__menu--hidden': !isTouch}">
                    <ohp-actions-menu [menuModel]="contextMenu"
                                      [listItemIndex]="index"
                                      [documentName]="item.fileName"
                                      [area]="instrumentationArea"
                                      [dataSecurity]="dataSecurityThreshold"
                                      [leftAlignedCard]="leftAlignActionsMenu"
                                      [iconClass]="fluentRefresh ? '' : 'commanding-item__icon ms-fcl-nd'"
                                      [actionContextMenuEnabled]="actionContextMenuEnabled"
                                      [actionContextMenu]="actionContextMenu"
                                      (menuToggled)="onActionsMenuToggle($event)"
                                      (menuFocused)="$event ? onFocus() : onBlur()"></ohp-actions-menu>
                </div>
            </div>
            <div *ngIf="!recommendedNewCards" class="document-card__info centered-flex-container" [ngClass]="{ 'document-card__info--expanded': uiCardType === 'borderless', 'document-card__info--fluent': fluentRefresh }">
                <div *ngIf="fluentRefresh && !mruAppType && !item.iconUrl" [class]="'document-card__title-icon ' + item.documentIconWithSize('32x32')" [ngClass]="{'document-card__title-icon--hidden': isUpcomingMeeting || isMyAnalytics}"></div>
                <img *ngIf="fluentRefresh && !mruAppType && item.iconUrl" class="document-icon--32x32 document-card__title-icon" src="{{item.iconUrl}}"/>
                <div *ngIf="!isUpcomingMeeting && !isMyAnalytics" class="list-item__flex-grow" [ngClass]="{'list-item--h-100': uiCardType === 'borderless'}">
                    <div class="list-item__title ms-fcl-nd"
                         [ngClass]="{ 'list-item__title--double-line': uiCardType === 'borderless', 'list-item__text--large': !fluentRefresh, 'list-item__text--large--fluent': fluentRefresh }">
                        <span *ngIf="uiCardType !== 'borderless'"
                              [ngClass]="{ 'ms-fcl-tp-h ms-fcl-tdr-f ms-fcl-tdr-a mru-list-item__title--themed': clickableFolderEnabled }"
                              [ohpHoverTelemetry]="instrumentationArea"
                              [title]="item.title"
                              #titleElement
                        >{{ item.title }}</span>
                        <h4 *ngIf="uiCardType === 'borderless'"
                            [ngClass]="{ 'ms-fcl-tp-h ms-fcl-tdr-f ms-fcl-tdr-a mru-list-item__title--themed': clickableFolderEnabled}"
                            [ohpHoverTelemetry]="instrumentationArea"
                            [title]="item.title"
                            #titleElement
                        >{{ item.title }}</h4>
                    </div>
                    <div class="list-item__text--small list-item__secondary ms-fcl-ns" *ngIf="!fluentRefresh && !!shortPath && uiCardType !== 'borderless'">
                        <span *ngIf="clickableFolderEnabled && (item.isEmailAttachment ? url : item.attributionUrl)"
                           class="ms-fcl-ns ms-fcl-tp-h ms-fcl-tdr-f ms-fcl-tdr-a attribution-link"
                           attr.data-href="{{ item.isEmailAttachment ? url : item.attributionUrl }}"
                           [attr.aria-label]="openFolderAriaLabel"
                           role="link"
                           tabindex="0"
                           title="{{ openFolderAriaLabel }}"
                           (click)="onPathClick($event)"
                           (keyup.enter)="onPathClick($event)"
                           (focus)="onFocus()"
                           (blur)="onBlur()"
                           [innerHTML]="shortPath">
                        </span>
                        <span *ngIf="!clickableFolderEnabled" [innerHTML]="shortPath" #attributionElement></span>
                    </div>
                    <div style="display:flex;">
                        <span *ngIf="isCardCreateByLabel && item?.createdBy"
                              class="list-item__text--small list-item__title ms-fcl-ns"
                              [ngClass]="{'document-card__text--small': fluentRefresh}">
                            <span [title]="item.createdBy">{{ item.createdBy }}</span>
                        </span>
                        <ohp-icon-font *ngIf="categoryIcon && categoryIcon.categoryFontIcon" [iconFontType]="categoryIcon && categoryIcon.categoryFontIcon"
                            size="16"
                            class="categories-card--center"
                            [cssClass]="'categories-card--center' + (isCardCreateByLabel && item?.createdBy ? ' categories--padding-left' : '')"
                            [attr.aria-label]="categoryIcon.categoryAriaLabel"
                            [title]="categoryIcon.categoryTooltip"
                            [color]="categoryIcon.categoryFontIconColor">
                        </ohp-icon-font>
                    </div>
                    <div *ngIf="isFormResponsesEnabled && borderlessCardDetail1"
                         class="list-item__text--small list-item__tertiary ms-fcl-nd list-item--bottom"
                         [ngClass]="{'document-card__text--small': fluentRefresh}">
                        <span [title]="borderlessCardDetail1" #titleElement>{{ borderlessCardDetail1 }}</span>
                    </div>
                </div>
                <div *ngIf="isUpcomingMeeting"
                     class="list-item__flex-grow"
                     [ngClass]="{'list-item--h-100': uiCardType === 'borderless'}"
                     (click)="onPathClick($event)"
                     (keyup.enter)="onPathClick($event)">
                    <div class="upcomingMeeting-card__join_text"
                         [ngClass]="{'upcomingMeeting-card__join_text--fluent' : fluentRefresh}">
                        <ohp-icon-font [iconFontName]="item.isTeamsMeeting ? 'Teams' : 'Calendar'"
                                        [cssClass]="'upcomingMeeting-card_logo' + (fluentRefresh ? ' upcomingMeeting-card_logo--fluent' : '')"
                                        size="16">
                        </ohp-icon-font>
                        <span
                            [attr.data-href]="item.joinUrl"
                                      [attr.aria-label]="item.joinMeetingText"
                                      role="link"
                                      tabindex="0"
                                      [title]="item.joinMeetingText"
                                      (focus)="onFocus()"
                            (blur)="onBlur()"
                            >{{ item.joinMeetingText }}
                        </span>
                    </div>
                </div>
                <div *ngIf="isMyAnalytics"
                     class="list-item__flex-grow"
                     [ngClass]="{'list-item--h-100': uiCardType === 'borderless'}"
                     (click)="disableClick()"
                     (keyup.enter)="disableClick()"
                      >
                    <div class="myAnalytics-card_action ms-fcl-tp">
                        <span *ngIf="myAnalyticsState === MYA_ITEM_VIEW_STATE"
                              class="myAnalytics-card_action_AddToTODo"
                              role="link"
                              tabindex="0"
                              [title]="addToToDoText"
                              (focus)="onFocus()"
                              (blur)="onBlur()"
                              (click)="onMyAnalyticsClick($event, PotentialActionType.PromoteTask)"
                              (keyup.enter)="onMyAnalyticsClick($event, PotentialActionType.PromoteTask)"
                              #myAnalyticsAddToDoLink
                            >{{ addToToDoText }}
                        </span>
                        <span *ngIf="myAnalyticsState === MYA_ITEM_ADDED_STATE" class="myAnalytics-card_viewInTodoIcon">
                            <ohp-icon-font  iconFontName="ToDo" size="24" cssClass="is-new-icon is-new-icon--tile ms-fcl-tp" [attr.aria-label]="viewInToDoText" [title]="viewInToDoText"></ohp-icon-font>
                        </span>
                        <span *ngIf="myAnalyticsState === MYA_ITEM_ADDED_STATE"
                              class="myAnalytics-card_action_ViewInToDo"
                              role="link"
                              tabindex="0"
                              [title]="viewInToDoText"
                              (focus)="onFocus()"
                              (blur)="onBlur()"
                              (click)="onViewToDoClick()"
                              (keyup.enter)="onViewToDoClick()"
                            >{{ viewInToDoText }}
                        </span>
                        <span
                            *ngIf="myAnalyticsState === MYA_ITEM_VIEW_STATE"
                              class="myAnalytics-card_action_Done"
                              role="link"
                              tabindex="0"
                              [title]="doneText"
                              (focus)="onFocus()"
                              (blur)="onBlur()"
                              (click)="onMyAnalyticsClick($event, PotentialActionType.MarkTaskAsDone)"
                              (keyup.enter)="onMyAnalyticsClick($event, PotentialActionType.MarkTaskAsDone)"
                            #myAnalyticsTaskDoneLink
                            >{{ doneText }}
                        </span>
                    </div>
                </div>
                <div *ngIf="showActionsMenu" class="document-card__menu" [ngClass]="{'document-card__menu--hidden': !isTouch}">
                    <ohp-actions-menu [menuModel]="contextMenu"
                                      [listItemIndex]="index"
                                      [documentName]="item.fileName"
                                      [area]="instrumentationArea"
                                      [dataSecurity]="dataSecurityThreshold"
                                      [leftAlignedCard]="leftAlignActionsMenu"
                                      [iconClass]="fluentRefresh ? '' : 'commanding-item__icon ms-fcl-nd'"
                                      [actionContextMenuEnabled]="actionContextMenuEnabled"
                                      [actionContextMenu]="actionContextMenu"
                                      (menuToggled)="onActionsMenuToggle($event)"
                                      (menuFocused)="$event ? onFocus() : onBlur()"></ohp-actions-menu>
                </div>
                </div>
        </div>
        <div *ngIf="showAsSuggestedAction() && primaryAction"
                    class="document-card document-card--suggested-action ms-bgc-w">
                    <div class="document-card__header document-card__header--fluent">
                        <ohp-activity-description [activities]="item.activities"
                                                    [lastViewedTime]="item.lastViewedTime"
                                                    [numLines]="2"
                                                    [activityDescriptionInput]="item.activity"
                                                    [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink"
                                                    [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink"
                                                    [docId]="item.docId"
                                                    [index]="index"
                                                    [fileType]="item.fileType"
                                                    [navId]="item.navigationId"
                                                    [showIcon]="!(item.activity?.people?.length > 0)"
                                                    [title]="item.title"
                                                    [timestampAndTitleInSameLine]="true"
                                                    [person]="item.activity?.people?.length > 0 && item.activity?.people[0] | activityPersonToPerson"
                                                    [area]="instrumentationArea">
                            <ohp-activity-description *ngIf="item.lastModifiedActivity && !item.activity"
                                                        [activities]="item.lastModifiedActivity"
                                                        [numLines]="2"
                                                        [activityDeepLink]="recommendedDeepLinkEnabled && activityDeepLink"
                                                        [teamsDeepLink]="recommendedTeamsLinkEnabled && teamsDeepLink"
                                                        [docId]="item.docId"
                                                        [index]="index"
                                                        [fileType]="item.fileType"
                                                        [navId]="item.navigationId"
                                                        [area]="instrumentationArea">
                            </ohp-activity-description>
                        </ohp-activity-description>
                        <div class="suggested-action--dismiss ms-fcl-bl"
                             (click)="removeItem($event)"
                             [innerHTML]="dismissIsHover ? dismissSquareFilled : dismissSquareRegular"
                             [title]="dismissItemTitle"
                             [attr.aria-label]="dismissItemTitle"
                             tabindex="0"
                             (mouseover)="dismissHover(true)"
                             (mouseleave)="dismissHover(false)">
                        </div>
                    </div>
            <ng-template *ngIf="isUpcomingMeeting" [ngTemplateOutlet]="upcomingMeetingTitle"></ng-template>
            <ng-template *ngIf="isMyAnalytics" [ngTemplateOutlet]="myAnalyticsTitle"></ng-template>
            <div *ngIf="!isUpcomingMeeting && !isMyAnalytics"
                 class="document-card__thumbnail-container document-card__thumbnail-container--suggested-actions"
                 [ngClass]="{ 'document-card__thumbnail-container--recommended': isRecommended || isOfficeFeed,
                              'document-card_thumbnail-container--rounded document-card__thumbnail-container--borderless': uiCardType === 'borderless' }">
                <ng-container *ngIf="thumbnailApiEnabled">
                    <div *ngIf="thumbnailLoaded"
                         class="opacity-overlay"></div>
                    <div *ngIf="!thumbnailLoaded"
                        [ngStyle]="{'background-color': workloadColorPromise | async }"
                        class="document-card--suggested-actions--fallback-background">
                    </div>
                    <div [hidden]="!thumbnailLoaded"
                         class="document-card__thumbnail-wrapper"
                         [ngClass]="{'document-card__thumbnail-wrapper--centered': centerThumbnail}">
                        <img *ngIf="thumbnail | async as image"
                             class="document-card__thumbnail"
                             [src]="image"
                             alt="{{ thumbnailAltText }}" />
                    </div>
                    <div class="document-card__icon-container ms-bgc-w">
                        <div class="mru-list-item__icon-in-preview icon--suggested-actions">
                            <div class="icon--suggested-actions--inner {{suggestedActionsIcon()}}"></div>
                        </div>
                    </div>
                    <div *ngIf="!thumbnailLoaded" class="icon--suggested-actions--fallback {{suggestedActionsIcon()}}"></div>
                </ng-container>
                <ng-container *ngIf="(!thumbnailApiEnabled) && thumbnailUrl">
                    <div *ngIf="thumbnailLoaded"
                         class="opacity-overlay"></div>
                    <div [hidden]="!thumbnailLoaded"
                         class="document-card__thumbnail-wrapper"
                         [ngClass]="{'document-card__thumbnail-wrapper--centered': centerThumbnail}"
                         [ngStyle]="{'background-color': (item.thumbnails  && item.thumbnails.backgroundColor ) ? item.thumbnails.backgroundColor  : 'transparent'}">
                        <img class="document-card__thumbnail"
                             [ngClass]="{'document-card__thumbnail-officefeed-news': isNewsArticle}"
                             [src]="!thumbnailSWEnabled ? thumbnailUrl : (thumbnailUrl | urlCachePipe | async)"
                             alt="{{ thumbnailAltText }}"
                             (load)="onThumbnailLoad()"
                             (error)="onThumbnailError()" />
                    </div>
                    <div class="document-card__icon-container ms-bgc-w">
                        <div class="mru-list-item__icon-in-preview icon--suggested-actions">
                            <div class="icon--suggested-actions--inner {{suggestedActionsIcon()}}"></div>
                        </div>
                    </div>
                    <div *ngIf="!thumbnailLoaded" class="icon--suggested-actions--fallback {{suggestedActionsIcon()}}"></div>
                </ng-container>
            </div>
            <div class="suggested-actions-buttons-container centered-flex-container">
                <div class="section__buttons-container suggested-actions-buttons-container__cta">
                    <button class="generic-button document-card__button--suggested-actions generic-button--fluentvnext--default"
                            (click)="onSelectPrimaryAction($event)"
                    >
                        <ohp-icon-font *ngIf="primaryActionIconFont"
                                       [iconFontType]="primaryActionIconFont"
                                       [size]="16"
                                       cssClass="icon--primary-action ms-fcl-bl">
                        </ohp-icon-font>
                        <div *ngIf="!primaryActionIconFont && showListSvg"
                             class="suggested-action--svg-icon ms-fcl-bl"
                             [innerHTML]="checklistIcon">
                        </div>
                        <div *ngIf="!primaryActionIconFont && showMeetingSvg"
                             class="suggested-action--svg-icon"
                             [ngClass]="{'suggested-action--svg--teams': item.isTeamsMeeting, 'ms-fcl-bl': !item.isTeamsMeeting}"
                             [innerHTML]="meetingIcon">
                        </div>
                        <div *ngIf="!primaryActionIconFont && showReplySvg"
                             class="suggested-action--svg-icon ms-fcl-bl"
                             [innerHTML]="replyIcon">
                        </div>
                        <span class="generic-button__text ms-fcl-bl">{{ primaryAction.title }}</span>
                    </button>
                </div>
                <div *ngIf="showActionsMenu"
                     class="list-item-column column--commanding">
                    <ohp-actions-menu [menuModel]="contextMenu"
                                      [iconClass]="fluentRefresh ? '' : 'commanding-item__icon ms-fcl-nd'"
                                      [listItemIndex]="index"
                                      [documentName]="item.fileName"
                                      [dataSecurity]="dataSecurityThreshold"
                                      [actionContextMenuEnabled]="actionContextMenuEnabled"
                                      [actionContextMenu]="actionContextMenu"
                                      (menuToggled)="onActionsMenuToggle($event)"
                                      (menuFocused)="$event ? onFocus() : onBlur()"
                                      [horizontalEllipsis]="true"></ohp-actions-menu>
                </div>
            </div>
        </div>
        <div *ngIf="showAsTile()" class="generic-tile" [ngClass]="{'generic-tile--shadowed': !fluentRefresh, 'ms-bgc-nlh-h ms-bgc-nlp-a': fluentRefresh}">
            <div class="generic-tile__images_container">
                <div *ngIf="thumbnailUrl" [hidden]="!thumbnailLoaded" [ngClass]="{'generic-tile__images': thumbnailLoaded}">
                    <img *ngIf="thumbnailSWEnabled"
                         class="generic-tile__thumbnail"
                         [ngClass]="'generic-tile__thumbnail--' + item.fileTypeName.toLowerCase()"
                         [ngStyle]="{'background-color': (item.thumbnails && item.thumbnails.backgroundColor ) ? item.thumbnails.backgroundColor : 'transparent'}"
                         [src]="thumbnailUrl | urlCachePipe | async"
                         alt="{{ thumbnailAltText }}"
                         (load)="onThumbnailLoad()"
                         (error)="onThumbnailError()" />
                    <img *ngIf="!thumbnailSWEnabled"
                         class="generic-tile__thumbnail"
                         [ngClass]="'generic-tile__thumbnail--' + item.fileTypeName.toLowerCase()"
                         [ngStyle]="{'background-color': (item.thumbnails && item.thumbnails.backgroundColor ) ? item.thumbnails.backgroundColor : 'transparent'}"
                         [src]="thumbnailUrl"
                         alt="{{ thumbnailAltText }}"
                         (load)="onThumbnailLoad()"
                         (error)="onThumbnailError()" />
                    <!--TODO: Remove once fabric icons are fully deprecated-->
                    <div *ngIf="iconFontClass()" class="document-tile__icon" [ngStyle]="{'color': iconFontColor()}">
                        <ohp-icon-font [iconFontCssClass]="iconFontClass()" size="16"></ohp-icon-font>
                    </div>
                    <div *ngIf="!iconFontClass()" class="document-tile__icon mru-list-item__document-icon-in-preview" [ngClass]="item.documentIconWithSize('20x20')"></div>
                </div>
                <div *ngIf="!thumbnailUrl || !thumbnailLoaded" class="generic-tile__fallback-image-container document-tile__fallback-image-container">
                    <div class="document-tile__fallback-image">
                        <div *ngIf="!item.iconUrl" [ngClass]="item.documentIconWithSize('64x64')"></div>
                        <img *ngIf="item.iconUrl" class="document-icon--64x64" src="{{item.iconUrl}}"/>
                    </div>
                </div>
            </div>
            <div class="document-tile__title-and-icons">
                <span [@fadeInIsNew]="isNewAnimationState">
                    <ohp-icon-font *ngIf="isNew" iconFontName="Glimmer" size="12" cssClass="is-new-icon is-new-icon--tile ms-fcl-tp" [attr.aria-label]="isNewTitle" [title]="isNewTitle"></ohp-icon-font>
                </span>
                <div class="document-tile__title list-item__text--medium ms-fcl-np">
                    <span [ngClass]="{ 'ms-fcl-tda-h mru-list-item__title--hover': clickableFolderEnabled }"
                          [ohpHoverTelemetry]="instrumentationArea"
                          #titleElement
                    >{{ item.title }}</span>
                </div>
            </div>
            <div class="document-tile__description-wrapper">
                <div class="document-tile__description-container">
                    <ohp-activity-description [activities]="showOnlyMruActivity ? [] : item.activities"
                                              [lastViewedTime]="item.lastViewedTime"
                                              [numLines]="1"
                                              iconSize="12"
                                              iconCssClass="document-tile__description__icon"
                                              [activityDescriptionInput]="mruActivity && item.activity"
                                              [useSolidIcon]="true">
                        <div class="document-tile__description" *ngIf="(showSharing && item.sharing?.shared) || !!shortPath">
                            <ohp-icon-font *ngIf="showSharing && item.sharing?.shared" iconFontName="People2" size="12" cssClass="document-tile__sharing document-tile__description__icon ms-fcl-np" [attr.aria-label]="sharedText"></ohp-icon-font>
                            <span *ngIf="clickableFolderEnabled && !!shortPath"
                               class="ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a ms-fcl-ns attribution-link document-tile__attribution"
                               [attr.aria-label]="openFolderAriaLabel"
                               attr.data-href="{{ item.isEmailAttachment ? url : item.attributionUrl }}"
                               role="link"
                               tabindex="0"
                               title="{{ openFolderAriaLabel }}"
                               (click)="onPathClick($event)"
                               (keyup.enter)="onPathClick($event)"
                               [innerHTML]="shortPath">
                            </span>
                            <span *ngIf="!clickableFolderEnabled && !!shortPath" class="document-tile__attribution list-item__text--small ms-fcl-ns" [innerHTML]="shortPath"></span>
                        </div>
                    </ohp-activity-description>
                </div>
            </div>
        </div>
        <div *ngIf="showAsListItem()" class="centered-flex-container list-item__height-restrictor">
            <!-- Name Column -->
            <div class="list-item-column"
                 [ngClass]="['document-column--name' + (!showActivity && !showAnalytics ? '--subset' : ''), mruAppSuffix ? ('document-column--name' + mruAppSuffix) : '', showMobileShareAndActivity ? 'document-column--name-mobile' : '']">
                <div class="list-item__icon {{ item.documentIcon }}" [attr.title]="item.fileTypeName" #fileIconElement></div>
                <div class="clip">
                    <div class="centered-flex-container">
                        <div class="list-item__text--large list-item__title ms-fcl-nd">
                            <span [ngClass]="{ 'ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a mru-list-item__title--themed': clickableFolderEnabled }"
                                  [ohpHoverTelemetry]="instrumentationArea"
                                  [title]="item.title"
                                  #titleElement
                            >{{ item.title }}</span>
                        </div>
                        <span [@fadeInIsNew]="isNewAnimationState">
                            <ohp-icon-font *ngIf="isNew" iconFontName="Glimmer" size="12" cssClass="is-new-icon ms-fcl-tp" [attr.aria-label]="isNewTitle" [title]="isNewTitle"></ohp-icon-font>
                        </span>
                        <ohp-icon-font *ngIf="showSharing && item.sharing?.shared"
                                       iconFontName="People2"
                                       size="14"
                                       [cssClass]="'ms-fcl-np document-column--name__share-icon' + (showMobileShareAndActivity ? ' document-column--name__share-icon--mobile' : '')"
                                       [attr.aria-label]="sharedText"
                                       [title]="sharedText"></ohp-icon-font>
                    </div>
                    <div class="list-item__text--small list-item__secondary ms-fcl-ns">
                        <div style="display: flex">
                            <div *ngIf="isCardCreateByLabel && item?.createdBy">
                                <span [title]="item.createdBy">{{ item.createdBy }}</span>
                            </div>
                            <ohp-icon-font *ngIf="categoryIcon && categoryIcon.categoryFontIcon" [iconFontType]="categoryIcon && categoryIcon.categoryFontIcon"
                                [iconFontCssClass]="(categoryIcon.categoryFontIconCssClass ? categoryIcon.categoryFontIconCssClass : '')"
                                size="16"
                                class="categories-card--center"
                                [attr.aria-label]="categoryIcon.categoryAriaLabel"
                                [title]="categoryIcon.categoryTooltip"
                                [cssClass]="'categories-card--center categories-listview' + (isCardCreateByLabel && item?.createdBy ? ' categories--padding-left' : '')"
                                [color]="categoryIcon.categoryFontIconColor"></ohp-icon-font>
                        </div>
                        <ohp-activity-description *ngIf="showMobileShareAndActivity; else showPath"
                                                [iconSize]="12"
                                                [numLines]="1"
                                                [activities]="showOnlyMruActivity ? [] : item.activities"
                                                [lastViewedTime]="item.lastViewedTime"
                                                [mobileListItem]="true"
                                                [activityDescriptionInput]="mruActivity && item.activity"
                                                [useSolidIcon]="true">
                            <ng-container *ngTemplateOutlet="showPath"></ng-container>
                        </ohp-activity-description>
                        <ng-template #showPath>
                            <span *ngIf="clickableFolderEnabled && !item.isEmailAttachment && item.attribution"
                               class="ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a ms-fcl-ns attribution-link"
                               [attr.aria-label]="openFolderAriaLabel"
                               attr.data-href="{{ item.isEmailAttachment ? url : item.attributionUrl }}"
                               role="link"
                               tabindex="0"
                               title="{{ openFolderAriaLabel }}"
                               (click)="onPathClick($event)"
                               (keyup.enter)="onPathClick($event)"
                               (focus)="onFocus()"
                               (blur)="onBlur()"
                               [innerHTML]="item.attribution">
                            </span>
                            <div *ngIf="item.isEmailAttachment">
                                {{ item.emailReference?.Subject }}
                            </div>
                            <span *ngIf="!clickableFolderEnabled && item.attribution" [innerHTML]="item.attribution" #attributionElement></span>
                        </ng-template>
                    </div>
                </div>
            </div>
            <!-- Commanding Column Left -->
            <div *ngIf="showActionsMenu" class="list-item-column column--commanding"
                 [ngClass]="{ 'column--commanding--hidden': !isTouch }">
                <span *ngIf="shareControlEnabled"
                   class="commanding-item ms-bgc-g40-h ms-bgc-g40-f ms-bgc-g40-a"
                   [ngClass]="{ 'commanding-item--responsive': !showMobileShareAndActivity, 'commanding-item--disabled': item.isLocal, 'column--commanding-mobile': showMobileShareAndActivity }"
                   [attr.aria-label]="shareActionTitle"
                   [title]="shareActionTitle"
                   keyboardFocusTooltip
                   (click)="onShareClick($event, 'topLevel', ShareControlMode.Share)"
                   (keyup.enter)="onShareClick($event, 'topLevel', ShareControlMode.Share)"
                   (focus)="onFocus()"
                   (blur)="onBlur()"
                   role="button"
                   tabindex="0"
                   aria-haspopup="true"
                   #shareTopLevel>
                    <ohp-icon-font iconFontName="Share2" size="16" cssClass="commanding-item__icon ms-fcl-nd" [ariaVisible]="true"></ohp-icon-font>
                </span>
                <span *ngIf="item.isLocal"
                   class="commanding-item--responsive commanding-item ms-bgc-g40-h ms-bgc-g40-f ms-bgc-g40-a"
                   [attr.aria-label]="uploadLocalFileTitle"
                   [title]="uploadLocalFileTitle"
                   keyboardFocusTooltip
                   (click)="uploadLocal($event)"
                   (keyup.enter)="uploadLocal($event)"
                   (focus)="onFocus()"
                   (blur)="onBlur()"
                   role="button"
                   tabindex="0"
                   aria-haspopup="true">
                    <ohp-icon-font iconFontName="Upload" size="16" cssClass="commanding-item__icon ms-fcl-nd" [ariaVisible]="true"></ohp-icon-font>
                </span>
                <span *ngIf="!item.isPinned && mruPinEnabled"
                   class="commanding-item--responsive commanding-item ms-bgc-g40-h ms-bgc-g40-f ms-bgc-g40-a"
                   [ngClass]="{'commanding-item--disabled' : item.isLocal}"
                   [attr.aria-label]="pinActionTitle"
                   [title]="pinActionTitle"
                   keyboardFocusTooltip
                   (click)="pinItem($event, 'topLevel')"
                   (keyup.enter)="pinItem($event, 'topLevel')"
                   (focus)="onFocus()"
                   (blur)="onBlur()"
                   tabindex="0"
                   role="button">
                    <ohp-icon-font [iconFontName]="pinActionIcon" size="16" cssClass="commanding-item__icon ms-fcl-nd" [ariaVisible]="true"></ohp-icon-font>
                </span>
                <span *ngIf="item.isPinned && mruPinEnabled"
                   class="commanding-item--responsive commanding-item ms-bgc-g40-h ms-bgc-g40-f ms-bgc-g40-a"
                   [attr.aria-label]="unpinActionTitle"
                   [title]="unpinActionTitle"
                   keyboardFocusTooltip
                   (click)="unpinItem($event, 'topLevel')"
                   (keyup.enter)="unpinItem($event, 'topLevel')"
                   (focus)="onFocus()"
                   (blur)="onBlur()"
                   tabindex="0"
                   role="button">
                    <ohp-icon-font [iconFontName]="unpinActionIcon" size="16" cssClass="commanding-item__icon ms-fcl-nd" [ariaVisible]="true"></ohp-icon-font>
                </span>
                <ohp-actions-menu
                    [menuModel]="contextMenu"
                    [iconClass]="fluentRefresh ? '' : 'commanding-item__icon ms-fcl-nd'"
                    [listItemIndex]="index"
                    [documentName]="item.fileName"
                    [dataSecurity]="dataSecurityThreshold"
                    [actionContextMenuEnabled]="actionContextMenuEnabled"
                    [actionContextMenu]="actionContextMenu"
                    (menuToggled)="onActionsMenuToggle($event)"
                    (menuFocused)="$event ? onFocus() : onBlur()"></ohp-actions-menu>
            </div>
            <!-- Spacer for actions menu when not enabled -->
            <div *ngIf="!showActionsMenu" class="list-item-column column--commanding"></div>
            <!-- Forms Responses Column -->
            <div *ngIf="isFormResponsesEnabled" class="list-item-column document-column--responses-forms">
                <div
                     class="list-item__text--small ms-fcl-ns"
                     [ngClass]="{ 'list-item__last-accessed': showActionsMenu }">
                     <!-- Todo: Localize Responses -->
                    {{ borderlessCardDetail1 }}
                </div>
            </div>
            <!-- Last opened Column -->
            <div class="list-item-column"
                 [ngClass]="{ 'document-column--last-opened': showActivity || showAnalytics,
                              'document-column--last-opened--right': !showSharing && !showActivity && !showAnalytics,
                              'document-column--last-opened--subset': showSharing && !showActivity && !showAnalytics }">
                <!-- Use the server-provided display time for the 16 markets we don't have angular i18n support for -->
                <div *ngIf="displayTime"
                     class="list-item__text--small ms-fcl-ns"
                     [ngClass]="{ 'list-item__last-accessed': showActionsMenu }"
                     #timestampElement>
                    {{ displayTime | responsiveRelativeDate:shortDate:displayTimeString:false }}
                </div>
            </div>
            <!-- Sharing Column -->
            <div class="list-item-column"
                 [ngClass]="{ 'document-column--sharing': showActivity, 'document-column--sharing--right': !showActivity }"
                 *ngIf="showSharing">
                <div *ngIf="listId === 'shared-mru'"
                     [ohpPeopleCard]="item.sharedByEmail"
                     class="activity-user-name sharing-column-name ms-fcl-nd"
                     title="{{ item.sharedByUsername }}">
                    {{ item.sharedByUsername }}
                </div>
                <ng-container *ngIf="listId !== 'shared-mru'">
                    <ohp-icon-font *ngIf="item.sharing?.shared" iconFontName="People2" size="14" cssClass="document-column--sharing__share-icon ms-fcl-np" aria-hidden="true"></ohp-icon-font>
                    <div class="list-item__text--small sharing-column--text ms-fcl-ns"
                         [ngClass]="{'sharing-column--text-shared': item.sharing?.shared}"
                         title="{{ item.sharing ? (item.sharing.shared ? sharedText : privateText) : '' }}">
                        {{ item.sharing ? (item.sharing.shared ? sharedText : privateText) : '' }}
                    </div>
                </ng-container>
            </div>
            <!-- Activity Column -->
            <div class="list-item-column document-column--activity" [ngClass]="{ 'document-column--activity-hidden': showMobileShareAndActivity }"
                 *ngIf="showActivity">
                <!-- TODO: Handle truncating at different breakpoints -->
                <ohp-activity-description *ngIf="activityEnabled"
                                          [activities]="showOnlyMruActivity ? [] : item.activities"
                                          [numLines]="mruActivity && item.activity ? 2 : undefined"
                                          [lastViewedTime]="item.lastViewedTime"
                                          [activityDescriptionInput]="mruActivity && item.activity">
                </ohp-activity-description>
            </div>
            <!-- Analytics Column -->
            <div class="list-item-column document-column--analytics document-analytics-container"
                 *ngIf="showAnalytics">
                <ohp-analytics-description [analytics]="item.analytics" (updateAriaLabel)="onAnalyticsDescriptionChanged($event)"></ohp-analytics-description>
            </div>
        </div>
    </a>
    <!-- TODO: style this correctly for tile -->
    <ng-container *ngIf="showDesktopShareControl">
        <div class="share-control"
             [ngClass]="{'mru-list-item__share-control mru-list-item__share-control--columns': showAsListItem()}"
             #shareControl>
            <ng-container ohpLazyView
                          ngModulePath="share-control#ShareControlModule"
                          [inputs]="{
                              file: item,
                              index: index,
                              mode: shareControlMode
                          }"
                          [outputs]="shareControlOutputs">
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-template #upcomingMeetingTitle>
    <div class="document-card__thumbnail-container upcomingMeeting-card__details"
         [ngClass]="{'document-card__thumbnail-container--suggested-actions': fluentRefresh }">
        <div [ngClass]="{'upcomingMeeting-card__left_rectangle': isUpcomingMeetingAccepted, 'upcomingMeeting-card__left_rectangle_dashed': !isUpcomingMeetingAccepted}">
        </div>
        <div class="upcomingMeeting-card__default upcomingMeeting-card__title upcomingMeeting-card__title--suggested_action"
             [title]="item.title"
             *ngIf="item.title">
            {{ item.title }}
        </div>
        <div class="upcomingMeeting-card__default upcomingMeeting-card__time">
            {{ item.startTime }} - {{ item.endTime }}
            <!-- for e.g 4 PM - 4:30 PM -->
        </div>
        <div class="upcomingMeeting-card__default upcomingMeeting-card__location"
             *ngIf="item.location"
             [title]="item.location">
            <ohp-icon-font iconFontName="Location"
                           size="16"
                           cssClass="upcomingMeeting-card__location__icon"></ohp-icon-font>
            {{ item.location }}
        </div>
        <div class="upcomingMeeting-card__attendees">
            <div *ngFor="let attendee of item.attendees?.slice(0,upcomingMeetingAttendeeDisplayMax)"
                 [ohpPeopleCard]="attendee.emailAddress.address"
                 class="upcomingMeeting-card__attendees__position">
                <ohp-person-picture *ngIf="attendee?.emailAddress"
                                    [isUpcomingMeeting]="true"
                                    [status]="attendee?.status?.response"
                                    [person]="attendee?.emailAddress | attendeeEmailAddressToPerson">
                </ohp-person-picture>
            </div>
            <!-- Display remaining count bubble-->
            <div *ngIf="upcomingMeetingAttendeeDisplayMax < item.attendees?.length"
                 class="person-picture-upcoming-meeting__display "
                 aria-hidden="true">
                <div class="person-picture-upcoming-meeting__text person-picture-upcoming-meeting__placeholder__text">
                    +{{ item.attendees?.length - upcomingMeetingAttendeeDisplayMax }}
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #myAnalyticsTitle>
    <div class="document-card__thumbnail-container"
         [ngClass]="{'document-card__thumbnail-container--suggested-actions document-card__thumbnail-container--myAnalytics': showAsSuggestedAction() || fluentRefresh}">
        <ohp-icon-font *ngIf="!showAsSuggestedAction()"
                    iconFontName="Outlook"
                    class="myAnalytics-card_icon"
                    size="24"></ohp-icon-font>
        <span *ngIf="!showAsSuggestedAction()"
            class="myAnalytics-card_title ms-fcl-bl"
            [title]="item.title">{{ item.title }}</span>
        <div>
            <span class="myAnalytics-card_text__messageBy ms-fcl-bl"
                  [ngClass]="{'myAnalytics-card_text__messageBy--suggested-action': showAsSuggestedAction()}">
                {{ item.insightDescriptionPrefix }},
                <span class="myAnalytics-card_text"
                      [ngClass]="{'ms-fcl-bl': !showAsSuggestedAction(),
                                  'myAnalytics-card_text--suggested-action': showAsSuggestedAction()}"
                      [title]="item.insightDescription">{{ item.insightDescription }}</span>
            </span>
        </div>
        <div *ngIf="showAsSuggestedAction()" class="document-card__icon-container ms-bgc-w">
            <ohp-icon-font iconFontName="Outlook"
                            size="20">
            </ohp-icon-font>
        </div>
    </div>
</ng-template>
